import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@idocs/shared-ui/core';
import { BillingBlockConfig } from 'libraries/ui/billing-ui/src/lib/components/billing-block/billing-block.component';
import { PaymentsHistoryInfo } from 'libraries/ui/billing-ui/src/lib/components/payments-history/payments-history.component';
import { PaymentsHistoryService } from '../../../services/billing/payments-history.service';
import { PaymentService } from '../../../services/billing/payment.service';
import { BillingPlanService } from '../../../services/billing/billing-plan.service';
import { AuthService } from '../../../services/auth/auth.service';
import * as moment from 'moment';
import { takeUntil, tap } from 'rxjs/operators';
import { apiResponseErrorHandler } from '../../../utils/handlers/api-error-handler';
import { showNotification } from '@idocs/shared-ui/notification';
import { saveAs } from 'file-saver';
import { BillingReportApiService } from '@idocs/api/business/services/BillingReport.api-service';
import { mapLeft, mapRight } from '@dev-stream/utils';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent extends BaseComponent implements OnInit {
    cardBlock: BillingBlockConfig<number> = new BillingBlockConfig<number>({
        title: 'Метод оплаты',
        buttonText: 'Изменить',
        data: 3,
    });
    historyBlock: BillingBlockConfig<number> = new BillingBlockConfig<number>({
        title: 'История платежей',
        buttonText: 'Вся история',
        data: 4,
    });
    payments: PaymentsHistoryInfo[] = [];
    loadingHistory = false;
    pageTitle = 'Дашборд';

    constructor(
        injector: Injector,
        public billingPlanService: BillingPlanService,
        public paymentService: PaymentService,
        public paymentsHistoryService: PaymentsHistoryService,
        private authService: AuthService,
        private _router: Router,
        private billingReportApi: BillingReportApiService
    ) {
        super(injector);
    }

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        this.loading = true;

        await this.billingPlanService.getBillingPlanAndSettings(true);

        await this.paymentsHistoryService.getData(5);

        this.loading = false;
    }

    get nextMonth() {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth() + 1, 1);
    }

    daysBeforePaymentLeft() {
        const today = new Date();
        return this.nextMonth
            ? Math.round(
                  (this.nextMonth.getTime() - today.getTime()) /
                      (1000 * 3600 * 24)
              )
            : 0;
    }

    getEndDateStr(d?: Date | null) {
        if (!d) {
            return 'текущий момент';
        }
        const today = new Date();
        const date = new Date(d);

        return +date > +today
            ? 'текущий момент'
            : moment(date).format('DD.MM.YYYY');
    }

    isInternalPackage() {
        return (
            !this.authService.isIndividual() &&
            this.billingPlanService.billingPlanVM?.InternalPackage
        );
    }

    async download(item: PaymentsHistoryInfo) {
        if (!item.Id) {
            return;
        }

        this.loadingHistory = true;

        this.billingReportApi
            .GetPaymentReportFile_byId(item.Id)
            .pipe(
                tap(() => (this.loadingHistory = false)),
                takeUntil(this.destroyed),
                mapRight((res) => {
                    const fileName = item.Name || '';
                    saveAs(res, `${fileName}.docx`, { autoBom: true });
                }),
                mapLeft(apiResponseErrorHandler),
                mapLeft(showNotification)
            )
            .subscribe();
    }

    async navigate(link: string) {
        await this._router.navigate([link]);
    }
}
